module.exports = __webpack_public_path__ + "static/img/1.b906988.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-h5/1.jpg
// module id = 3fK4
// module chunks = 2